import {
  createFileRoute,
  useNavigate,
  useRouter,
  useSearch,
} from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { validatePackageAccess } from "@/lib/assist-package-guard";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql.ts";
import { LEGACY_SUBSCRIPTION_PAGE_FEATURES } from "@/lib/constants/subscribe-assist-pro";
import {
  SubscribeAssistProBenefitsFeatures,
  SubscribeAssistProBenefitsLPLink,
  SubscribeAssistProBenefitsRoot,
  SubscribeAssistProBenefitsTitle,
} from "@/components/assist/subscribe-assist-pro/subscribe-assist-pro-benefits";
import { SubscribeAssistProCard } from "@/components/assist/subscribe-assist-pro/subscribe-assist-pro-card";
import { trackEvent } from "@/lib/tracking";
import { SubscribeAssistProSubscriptionCardButtons } from "@/components/assist/subscribe-assist-pro/subscribe-assist-pro-subscription-card";
import { ServicePackageEnum } from "@/lib/enums/service-package-enum";

import type { JSX } from "react";

const RETURN_URL = "/settings";

const ServicePackagesQuery = graphql(/* GraphQL */ `
  query ServicePackagesQuery($codPacoteServico: Int!) {
    ...ServicePackagesFragment
  }
`);

const SubscribeAssistProLegacyPage = (): JSX.Element => {
  const navigate = useNavigate();
  const router = useRouter();
  const { navigateBack } = useSearch({
    from: "/settings/assist/subscribe-assist-pro-legacy/",
  });
  const professionalServicePackageEnumValue: number = ServicePackageEnum.Pro.valueOf();
  const queryResult = useGraphQL(ServicePackagesQuery, {
    codPacoteServico: professionalServicePackageEnumValue,
  });
  const { data } = queryResult;

  const onDeclineClick = (): void => {
    trackEvent("Botão Decidir Depois Assist Pro Clicado", {
      destino: RETURN_URL,
    });

    void navigate({
      to: RETURN_URL,
    });
  };

  const onBackClick = (): void => {
    if (navigateBack) {
      router.history.back();
    } else {
      void navigate({
        to: RETURN_URL,
      });
    }
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton onClick={onBackClick} icon={Left} align="start" />
        <HeaderTitle title="Livance Assist Pro" align="center" />
      </HeaderRoot>
      <Page className="px-0 pb-0 flex flex-col">
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <>
              <SubscribeAssistProBenefitsRoot>
                <SubscribeAssistProBenefitsTitle />
                <SubscribeAssistProBenefitsFeatures />
                <SubscribeAssistProBenefitsLPLink url="https://livance.com.br/lp/livanceassistpro-legado" />
              </SubscribeAssistProBenefitsRoot>

              <SubscribeAssistProCard
                data={data}
                features={LEGACY_SUBSCRIPTION_PAGE_FEATURES}
              />

              <SubscribeAssistProSubscriptionCardButtons
                onAcceptClick={() => {
                  trackEvent("Botão Aceitar Assist Pro Clicado");
                  void navigate({
                    to: "/settings/assist/subscribe-assist-pro/confirm",
                  });
                }}
                onDeclineClick={onDeclineClick}
              />
            </>
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/subscribe-assist-pro-legacy/")({
  component: SubscribeAssistProLegacyPage,
  beforeLoad: ({ context }) => {
    const user = context.user;
    validatePackageAccess({
      user,
      packageService: ServicePackageEnum.Legacy,
    });
  },
});
